import { Component, OnInit, isDevMode } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '../auth.service';
import { IUserCredentials } from '../shared.interface';

import { MessengerService } from '../messenger.service'; 

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent implements OnInit {
  dev_mode: boolean = isDevMode();
  
  currentUser: IUserCredentials;
  isAuth: boolean = false;
  user_avatar: string;
  messenger_init: boolean = false;

  constructor(
    private auth: AuthService, 
    public router: Router,
    public messenger_service: MessengerService
  ) { }

  ngOnInit() {
    this.router.events.subscribe(state => {
      if (state['url']) {
        this.currentUser = this.auth.get_current_user();
        this.user_avatar = this.currentUser.picture;
        // this.isAuth = (this.currentUser.access_token) ? true : false;

        if (this.currentUser.access_token) {
          this.isAuth = true;
          if (!this.messenger_init) {
            this.messenger_service.init();
            this.messenger_init = true;
          }
        } else {
          this.isAuth = false;
        }
      }
    });
  }

  logout(){
    // localStorage.clear();
    ['version', 'scopes', 'token', 'iwd'].map(item => localStorage.removeItem(`yoola_app:${item}`));
    this.router.navigate(['login']);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/toolbar/toolbar.component.ts